import { render } from "./AdminPeakfactorEdit.vue?vue&type=template&id=8b702bce&scoped=true&ts=true&lang=true"
import script from "./AdminPeakfactorEdit.vue?vue&type=script&lang=ts"
export * from "./AdminPeakfactorEdit.vue?vue&type=script&lang=ts"

import "./AdminPeakfactorEdit.vue?vue&type=style&index=0&id=8b702bce&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8b702bce"]])

export default __exports__